import { api } from "../services/api";

export function getLocatorPictureUrl(pictureLink?: string | null): string | null {
  if (!pictureLink || typeof pictureLink !== "string") return null;
  if (
    pictureLink.startsWith("http://") ||
    pictureLink.startsWith("https://") ||
    pictureLink.startsWith("blob:") ||
    pictureLink.startsWith("data:")
  ) {
    return pictureLink;
  }

  const cleanPath = pictureLink.startsWith("/") ? pictureLink.slice(1) : pictureLink;

  if (process.env.REACT_APP_STORAGE_BASE_URL) {
    const storageBase = process.env.REACT_APP_STORAGE_BASE_URL.endsWith("/")
      ? process.env.REACT_APP_STORAGE_BASE_URL
      : `${process.env.REACT_APP_STORAGE_BASE_URL}/`;
    return `${storageBase}${cleanPath}`;
  }

  const apiBase = (api.defaults.baseURL || "http://localhost:8080").replace(/\/$/, "");
  return `${apiBase}/files/${cleanPath}`;
}
